import { Banner } from '@/components/Banner/Banner';
import { languageStrings } from '@/l18n/de';
import { setInnerHTML } from '@/lib/util';
import { getPurUrl } from '@/lib/banner';
import type { Bundle } from '@/components/Store.d';

type Props = {
  bundle: Bundle | null;
};

const BannerNotQualified = ({ bundle }: Props) => {
  const ctaUrl = getPurUrl(bundle);

  return (
    <Banner className="banner-warning">
      <div className="banner--active-hint">
        <strong>{languageStrings.notQualifiedForCheaperPur.heading}</strong>
        <span dangerouslySetInnerHTML={setInnerHTML(languageStrings.notQualifiedForCheaperPur.explanation(ctaUrl))}></span>
      </div>
    </Banner>
  );
};

export { BannerNotQualified };
